var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.285 7.68911C21.9504 7.3545 21.392 7.24361 20.9501 7.6982L14.993 13.6554L9.036 7.69839C8.66759 7.31937 8.05854 7.32039 7.69466 7.69586C7.33096 8.07149 7.33956 8.66366 7.71022 9.02425L13.6672 14.9812L7.71003 20.9384C7.331 21.3068 7.33201 21.9158 7.70721 22.2797C8.08284 22.6434 8.675 22.6348 9.0356 22.2641L14.9928 16.307L20.9497 22.264C21.8335 23.1731 23.1847 21.8219 22.2755 20.9381L16.3186 14.9812L22.2757 9.02402C22.7306 8.58241 22.6193 8.02373 22.285 7.68911Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.270a9ee378cf29dadecbb1930b10f19a.svg";
export { ForwardRef as ReactComponent };